import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export default function CreateDocumentClassificationDialog({ open, onClose, onCreate, defaultDomain, documentDomains }) {
    const [classificationName, setClassificationName] = useState('');
    const [losDoc, setLosDoc] = useState('');
    const [domainId, setDomainId] = useState(defaultDomain || '');

    const isNameValid = classificationName.trim().length > 0;

    // Update the selected domain when defaultDomain prop changes.
    useEffect(() => {
        setDomainId(defaultDomain);
    }, [defaultDomain]);

    const handleSubmit = () => {
        // Pass the new classification data back to the caller.
        onCreate({
             classificationName: classificationName.trim(),
             alias: losDoc,
             documentDomainId: domainId
        });
        // Optionally reset the fields (except the domain, if you want to keep it)
        setClassificationName('');
        setLosDoc('');
    };

    return (
        <Dialog open={open} onClose={onClose} PaperProps={{ sx: { width: '600px' } }}>
            <DialogTitle>Create New Classification</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <TextField
                        label="Classification Name"
                        value={classificationName}
                        onChange={(e) => setClassificationName(e.target.value)}
                        fullWidth
                        error={!isNameValid}
                        helperText={!isNameValid ? 'Name is required' : ''}
                    />
                    <TextField
                        label="LOS Doc"
                        value={losDoc}
                        onChange={(e) => setLosDoc(e.target.value)}
                        fullWidth
                    />
                    <FormControl fullWidth>
                        <InputLabel id="domain-select-label">Document Domain</InputLabel>
                        <Select
                            labelId="domain-select-label"
                            value={domainId}
                            label="Document Domain"
                            onChange={(e) => setDomainId(e.target.value)}
                        >
                            {documentDomains.map((domain) => (
                                <MenuItem key={domain.domainId} value={domain.domainId}>
                                    {domain.domainName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={!isNameValid}
                >
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
}
